import React from 'react';

import { ColoredSpan } from 'common/typography';

import { WelcomeWrapper, StyledHeading, StyledParagraph } from './styled';

export const QuestionnaireWelcome: React.FC<QuestionnaireWelcomeProps> = ({ isBusQuestionnaire = false }) => {

  return (
    <WelcomeWrapper>
      {isBusQuestionnaire ? (
        <>
          <StyledHeading as="h2" margin="32px 0 16px 0">
            Benieuwd naar welke <ColoredSpan>elektrische bestelbus </ColoredSpan>
            het beste bij jou past?
          </StyledHeading>
          <StyledParagraph noMargin variant="gray">
            <b>Vul 7 korte vragen in over jouw gewenste gebruik, en ontvang direct een persoonlijk advies.</b>
          </StyledParagraph>
        </>
      ) : (
        <>
          <StyledHeading as="h1" margin="32px 0 16px 0">
            Wat kost zakelijk elektrisch rijden?
          </StyledHeading>
          <StyledParagraph margin="0 0 20px 0">
            Bereken binnen 2 minuten hoeveel <b>duizenden euro’s</b> het jou kan opleveren.
          </StyledParagraph>
          <StyledParagraph noMargin>
            In jouw rapport lees je alles over <b>subsidies, belastingvoordeel en energiekosten.</b>
          </StyledParagraph>
        </>
      )}
    </WelcomeWrapper>
  );
};

type QuestionnaireWelcomeProps = {
  isBusQuestionnaire?: boolean;
};

